"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var paymentEwayStyles = styles_1.makeStyles(function (_a) {
    var typography = _a.typography, palette = _a.palette;
    return ({
        container: {},
        initButton: {},
        subtitle: {
            fontWeight: typography.fontWeightBold,
            fontSize: '20px',
            textAlign: 'center',
            paddingBottom: '10px',
        },
        description: {
            fontSize: '16px',
            textAlign: 'center',
            paddingBottom: '10px',
            whiteSpace: 'pre-wrap',
        },
        payButton: {
            margin: '30px auto',
            display: 'block',
            maxWidth: 'unset',
            width: 'fit-content',
            minWidth: '270px',
        },
        email: {
            display: 'inline',
            color: palette.primary.main,
            textDecoration: 'underline',
        },
        description2: {
            fontSize: typography.fontMD,
            textAlign: 'center',
            marginTop: '20px',
            display: 'block',
        },
    });
}, { name: 'Gql_PaymentEway' });
exports.default = paymentEwayStyles;
